export const GET_BLACK_LIST_REQUEST = 'GET_BLACK_LIST_REQUEST' as const;
export const GET_BLACK_LIST_SUCCESS = 'GET_BLACK_LIST_SUCCESS' as const;
export const GET_BLACK_LIST_ERROR = 'GET_BLACK_LIST_ERROR' as const;

export const POST_BLACK_LIST_REQUEST = 'POST_BLACK_LIST_REQUEST' as const;
export const POST_BLACK_LIST_SUCCESS = 'POST_BLACK_LIST_SUCCESS' as const;
export const POST_BLACK_LIST_ERROR = 'POST_BLACK_LIST_ERROR' as const;

export const DELETE_BLACK_LIST_REQUEST = 'DELETE_BLACK_LIST_REQUEST' as const;
export const DELETE_BLACK_LIST_SUCCESS = 'DELETE_BLACK_LIST_SUCCESS' as const;
export const DELETE_BLACK_LIST_ERROR = 'DELETE_BLACK_LIST_ERROR' as const;
